import React from "react";
import { createRoot } from 'react-dom/client';
import { Quiz } from "./components/Quiz";

export const mount = (props) => {
    const container = document.getElementById(props.containerId)
    const root = createRoot(container);
    return root.render(<Quiz {...props} />);
}